export default __webpack_public_path__ + "static/media/151.ec6bf7b5.gif";